//Base colors - main vars
const basicColors = {
  primaryColor: '#FF0000',
  secondaryColor: '#FF0080',
  blackColor: '#0A0B10',
  whiteColor: '#FFFFFF',
  activeColor: '#AFDF20',
  warningColor: '#FF8000',
  linkColor: '#0095FF',
  successColor: '#20df20',
  errorColor: '#FF0000',
}

//Color variations
const primary = {
  _50: '#1A000E',
  _100: '#2E0B10',
  _150: '#450F11',
  _200: '#5E1112',
  _250: '#761312',
  _300: '#911311',
  _350: '#AA130F',
  _400: '#C6100C',
  _450: '#E30A07',
  _500: basicColors.primaryColor,
  _550: '#FF4728',
  _600: '#FF6742',
  _650: '#FF7F5B',
  _700: '#FF9573',
  _750: '#FFAA8A',
  _800: '#FFBCA1',
  _850: '#FFCFB7',
  _900: '#FFE0CE',
  _950: '#FFF2E5',
}

const secondary = {
  _50: '#1A0019',
  _100: '#2D0B22',
  _150: '#450E2D',
  _200: '#5D1138',
  _250: '#761244',
  _300: '#8F134F',
  _350: '#AA125B',
  _400: '#C70F67',
  _450: '#E20A73',
  _500: basicColors.secondaryColor,
  _550: '#FF438C',
  _600: '#FF6097',
  _650: '#FF79A3',
  _700: '#FF8EAE',
  _750: '#FFA0B9',
  _800: '#FFB2C4',
  _850: '#FFC3CF',
  _900: '#FFD5DA',
  _950: '#FFE5E5',
}

const black = {
  _50: basicColors.blackColor,
  _100: '#171A1E',
  _150: '#20252B',
  _200: '#2A3138',
  _250: '#343F46',
  _300: '#3F4C55',
  _350: '#495B65',
  _400: '#546974',
  _450: '#607784',
  _500: '#6B8694',
  _550: '#79929E',
  _600: '#879EA9',
  _650: '#96AAB3',
  _700: '#A4B6BD',
  _750: '#B3C3C9',
  _800: '#C2CED3',
  _850: '#D1DCDE',
  _900: '#E0E8E9',
  _950: '#EFF5F4',
}

const active = {
  _50: '#071A00',
  _100: '#192C0B',
  _150: '#294010',
  _200: '#3A5313',
  _250: '#4C6917',
  _300: '#5F8019',
  _350: '#72971C',
  _400: '#86AE1E',
  _450: '#9AC71F',
  _500: basicColors.activeColor,
  _550: '#B9E241',
  _600: '#C3E559',
  _650: '#CDE559',
  _700: '#D6EB84',
  _750: '#DFEE96',
  _800: '#E8F0AB',
  _850: '#F0F3BF',
  _900: '#F8F6D3',
  _950: '#FFF9E5',
}

const error = {
  _50: '#1A000E',
  _100: '#2E0B10',
  _150: '#450F11',
  _200: '#5E1112',
  _250: '#761312',
  _300: '#911311',
  _350: '#AA130F',
  _400: '#C6100C',
  _450: '#E30A07',
  _500: basicColors.primaryColor,
  _550: '#FF4728',
  _600: '#FF6742',
  _650: '#FF7F5B',
  _700: '#FF9573',
  _750: '#FFAA8A',
  _800: '#FFBCA1',
  _850: '#FFCFB7',
  _900: '#FFE0CE',
  _950: '#FFF2E5',
}

const warning = {
  _50: '#240000',
  _100: '#361108',
  _150: '#4C1C0D',
  _200: '#632910',
  _250: '#7B3611',
  _300: '#944511',
  _350: '#AD5310',
  _400: '#C8610D',
  _450: '#E37008',
  _500: basicColors.warningColor,
  _550: '#FF902F',
  _600: '#FFA04B',
  _650: '#FFAF64',
  _700: '#FFBE7A',
  _750: '#FFCC91',
  _800: '#FFD8A6',
  _850: '#FFE5BB',
  _900: '#FFF2D0',
  _950: '#FFFFE5',
}

const success = {
  _50: '#001A0D',
  _100: '#0A2B13',
  _150: '#0F3F17',
  _200: '#13531B',
  _250: '#17691D',
  _300: '#1A8020',
  _350: '#1C9621',
  _400: '#1EAD22',
  _450: '#1FC721',
  _500: basicColors.successColor,
  _550: '#52E441',
  _600: '#6EE859',
  _650: '#86EB6F',
  _700: '#9AEF83',
  _750: '#ADF396',
  _800: '#BFF6AA',
  _850: '#D2F9BE',
  _900: '#E3FCD2',
  _950: '#F3FFE5',
}

const colors = {
  ...basicColors,
  primary,
  secondary,
  black,
  active,
  error,
  warning,
  success,
}

export default colors



// WEBPACK FOOTER //
// ./src/global/colors.js